import type { FC } from 'react';
import { Avatar, Input } from 'antd';
import { TbRefresh } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { generateRandomHexValue, SmallTooltip } from '@/shared';
import { PlatformColorPicker } from '@/shared/components/forms';

interface WhitelabelColorInputProps {
    fallbackValue?: string;
    onChange: (value: string) => void;
    placeholder?: string;
    value?: string;
}

const WhitelabelColorInput: FC<WhitelabelColorInputProps> = ({
    fallbackValue = '#000000',
    onChange,
    placeholder,
    value = '',
}): JSX.Element => {
    const { token } = useAntDesignTheme();
    const previewColor = value || fallbackValue;

    return (
        <Input
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            prefix={
                <PlatformColorPicker value={previewColor} onChange={(color) => onChange(color.toHexString())}>
                    <Avatar
                        size={18}
                        shape='square'
                        style={{
                            backgroundColor: previewColor,
                            border: `1px solid ${token.colorBorder}`,
                            cursor: 'pointer',
                            marginRight: '0.25rem',
                        }}
                    />
                </PlatformColorPicker>
            }
            suffix={
                <SmallTooltip title='Randomize...' placement='right' padding='0 0.5rem'>
                    <TbRefresh
                        aria-label='Randomize color'
                        role='button'
                        size='1rem'
                        tabIndex={0}
                        style={{ color: token.colorTextTertiary, cursor: 'pointer' }}
                        onClick={() => onChange(generateRandomHexValue())}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                onChange(generateRandomHexValue());
                            }
                        }}
                    />
                </SmallTooltip>
            }
        />
    );
};

export default WhitelabelColorInput;
